"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { DEFAULT_CHAINS } from "../chains/constants";
import { ChainsContext } from "../hooks/use-chains";
export function ChainsProvider(t0) {
  const $ = _c(5);
  const {
    chains: t1,
    children
  } = t0;
  const chains = t1 === undefined ? DEFAULT_CHAINS : t1;
  let t2;
  let t3;
  if ($[0] !== chains) {
    t3 = {
      chains
    };
    $[0] = chains;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  t2 = t3;
  const value = t2;
  let t4;
  if ($[2] !== children || $[3] !== value) {
    t4 = <ChainsContext.Provider value={value}>{children}</ChainsContext.Provider>;
    $[2] = children;
    $[3] = value;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}